import { useContext } from 'react';

import { PortalContainerContext } from '@/lib/context/portal-container';

// Use this hook to access a ref to the closest drawer content element. Useful when you want to use a React
// portal within a drawer to avoid unexpected behaviour
export const usePortalContainerRef = () => {
  return useContext(PortalContainerContext);
};
